import {
  DetalleSimulacionResponseSchema,
  MisSimulacionesResponseSchema,
  type DetalleSimulacionResponse,
  type MisSimulacionesResponse,
} from '@alter/types';
import type { HttpClient } from './httpClient.js';

/**
 * Endpoints REST de bitácora (`02_CONTRATOS.md` §1).
 *
 * Filtros por rol viven en el backend:
 * - ALUMNO: ve sólo sus simulaciones; el campo `alumno` no se envía
 * - Otros roles: ven todas las del tenant
 *
 * INV-04: `metricas_finales` en el detalle se **renderiza** sólo para
 * TUTOR/ADMINISTRADOR/VALIDADOR_CLINICO. El backend sigue enviándolas en
 * algunos casos; la guardia de visibilidad es responsabilidad de la app.
 */
export class BitacoraClient {
  constructor(private readonly http: HttpClient) {}

  /** §4.1 `GET /api/mis-simulaciones`. */
  async getMisSimulaciones(): Promise<MisSimulacionesResponse> {
    return this.http.get('/api/mis-simulaciones', MisSimulacionesResponseSchema);
  }

  /** §4.2 `GET /api/simulacion/:id/detalle`. */
  async getDetalle(simulacionId: string): Promise<DetalleSimulacionResponse> {
    const path = `/api/simulacion/${encodeURIComponent(simulacionId)}/detalle`;
    return this.http.get(path, DetalleSimulacionResponseSchema);
  }
}
